import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  LinkedBankAccount,
  type LinkedBankAccountConstructor,
} from './LinkedBankAccount'
import { LinkedBankAccountStatuses } from '../enums/LinkedBankAccountStatusEnum'

export const LinkedBankAccountConstructorFactory =
  Factory.Sync.makeFactory<LinkedBankAccountConstructor>({
    id: Factory.each(() => faker.random.number()),
    uuid: Factory.each(() => faker.random.uuid()),
    bankName: Factory.each(() => faker.company.companyName()),
    accountName: Factory.each(() => faker.finance.accountName()),
    accountMask: Factory.each(() => faker.finance.account(4)),
    status: LinkedBankAccountStatuses.VERIFIED,
    glCode: Factory.each(() => faker.random.alphaNumeric(6)),
  })

export const LinkedBankAccountFactory = EntityFactory(
  LinkedBankAccount,
  LinkedBankAccountConstructorFactory
)
